import React, { useEffect, useMemo, useRef, useState } from "react"
import { MainContainer, NextUITable, ErrorCard, LoadingCard, VirtualizeAutoComplete } from "../../components"
import {
  Button,
  Autocomplete,
  AutocompleteItem,
  Select,
  SelectItem,
  Checkbox,
  Input, Popover, PopoverContent, PopoverProvider, PopoverTrigger
} from "@nextui-org/react"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFilter, faList, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import "react-date-range/dist/styles.css" // main css file
import "react-date-range/dist/theme/default.css" // theme css file

import { apiRoute, linksUrl } from "../../constants/enum.js"
import { useFetchWithBody, useGet, usePost } from "../../api/reactQueryCustomHooks.jsx"
import { resetGrayFilter, setCurrentGrayStock, setFilter } from "../../state/grayStockSlice.jsx"
import { calculateTotal } from "../../Utility/utility.js"
import { COLUMN_TYPE, FOOTER_TYPE } from "../../components/NextUITable.jsx"
import { isMobile } from "react-device-detect"
import { combineSlices } from "@reduxjs/toolkit"
import { toast } from "react-toastify"
import { useModalToast } from "../../components/modalToast/ModalToastContext"

const GrayStock = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [filterAging, setFilterAging] = useState({ age1: 45, age2: 60, age3: 90, age4: 120 })
  const [data, setData] = useState([])
  const enum_filterFieldId = {
    item: "itemCode",
    mitem: "mitemCode",
    unit: "unitId"
  }

  const { currentGrayStock, filter } = useSelector((state) => state.grayStock)
  const [filterDate, setFilterDate] = useState({
    start: filter?.fromdate || null,
    end: filter?.todate || null,
  })
  const { show } = useModalToast()
  const [isAgingSummary, setIsAgingSummary] = useState(filter?.isAging || false)
  const [msg, setMsg] = useState("")
  const [applyAging, setApplyAging] = useState({ age1: 45, age2: 60, age3: 90, age4: 120 })
  //const [data, setData] = useState([])
  const [selectedItem, setSelectedItem] = useState(filter?.itemCode || "")
  // { key: filter && filter.itemCode ? filter.itemCode : "", value: filter && filter.itemName ? filter.itemName : "" }
  const [selectedMitem, setSelectedMitem] = useState(filter?.mitemCode || "")
  const [selectedUnit, setSelectedUnit] = useState(filter?.unitId || "")
  // key: filter && filter.mitemCode ? filter.mitemCode : "", value: filter && filter.mitemName ? filter.mitemName : "" 
  const { compCode } = useSelector((state) => state.company)

  const inputRef = useRef(null);
  const { isLoading, isError: isErrorFetch, data: itemDetails = [] } = useFetchWithBody({
    url: apiRoute.grayStock.fetchItemMaster,
    queryKey: "GrayStockItemMaster",
  })

  const {
    isPending,
    isError,
    data: grayStock = [],
    mutate: filterGrayStock,
  } = usePost({
    url: apiRoute.grayStock.fetch,
    queryKey: "GrayStock",
    onSuccessTasks: (data) => {
      setData(data)

    }
  })

  const {
    isPending: isPendingAging,
    isError: isErrorAging,
    data: agingGrayStock = [],
    mutate: filterAgingGrayStock,
  } = usePost({
    url: apiRoute.grayStock.fetchAging,
    queryKey: "GrayAgingStock",
    onSuccessTasks: (data) => {
      setData(data)

    }
  })
  const { data: unitMaster = [] } = useFetchWithBody({
    url: apiRoute.report.invoice.getUnit,
    queryKey: "Fetch Unit data",
    inputData: {
      compcode: compCode.join(",")
    }
  })
  const aging = useMemo(() => {
    return {
      Age1: `<=${filterAging?.age1}`
      , Age2: `>${filterAging?.age1}<=${filterAging?.age2}`
      , Age3: `>${filterAging?.age2}<=${filterAging?.age3}`
      , Age4: `>${filterAging?.age3}<=${filterAging?.age4}`
      , Age5: `>${filterAging?.age4}`
    }
  }, [filterAging])

  let totalTaka = useMemo(
    () =>
      isAgingSummary ? 0 : calculateTotal({
        data: grayStock,
        columnName: "Taka",
      }),
    [grayStock, isAgingSummary]
  )
  let totalMeter = useMemo(
    () =>
      isAgingSummary ? 0 : calculateTotal({
        data: grayStock,
        columnName: "Meter",
      }),
    [grayStock, isAgingSummary]
  )

  const totalAge1 = useMemo(
    () =>

      calculateTotal({
        data: agingGrayStock,
        columnName: aging?.Age1,
      }),
    [agingGrayStock, isAgingSummary]
  )
  const totalAge2 = useMemo(
    () =>
      calculateTotal({
        data: agingGrayStock,
        columnName: aging?.Age2,
      }),
    [agingGrayStock, isAgingSummary]
  )
  const totalAge3 = useMemo(
    () =>
      calculateTotal({
        data: agingGrayStock,
        columnName: aging?.Age3,
      }),
    [agingGrayStock, isAgingSummary]
  )
  const totalAge4 = useMemo(
    () =>
      calculateTotal({
        data: agingGrayStock,
        columnName: aging?.Age4,
      }),
    [agingGrayStock, isAgingSummary]
  )
  const totalAge5 = useMemo(
    () =>
      calculateTotal({
        data: agingGrayStock,
        columnName: aging?.Age5,
      }),
    [agingGrayStock, isAgingSummary]
  )


  let downloadDataFooter = useMemo(() => {
    if (isAgingSummary)
      return {
        item_code: "",
        item_desc: "",
        [aging?.Age1]: "Total: " + totalAge1,
        [aging?.Age2]: "Total: " + totalAge2,
        [aging?.Age3]: "Total: " + totalAge3,
        [aging?.Age4]: "Total: " + totalAge4,
        [aging?.Age5]: "Total: " + totalAge5,
      }
    else
      return {
        item_code: "",
        item_desc: "",
        Taka: "Total: " + totalTaka,
        Meter: "Total: " + totalMeter,
      }
  }, [isAgingSummary, agingGrayStock])

  const exportColumns = useMemo(() => {
    if (isAgingSummary) {
      return [{
        uid: "item_code",
        name: "Item Code",
      },
      {
        uid: "item_desc",
        name: "Item Desc",
      },
      {
        uid: aging?.Age1,
        name: aging?.Age1,

      },
      {
        uid: aging?.Age2,
        name: aging?.Age2,

      },
      {
        uid: aging?.Age3,
        name: aging?.Age3,

      },
      {
        uid: aging?.Age4,
        name: aging?.Age4,

      },
      ];
    }
    else
      return [
        {
          uid: "item_code",
          name: "Item Code",
        },
        {
          uid: "item_desc",
          name: "Item Desc",
        },
        {
          uid: "Taka",
          name: "Taka",
        },
        {
          uid: "Meter",
          name: "Meter",
        },
      ]
  }, [isAgingSummary, filterAging])

  useEffect(() => {
    funFilterData(isAgingSummary, filterAging?.age1, filterAging?.age2, filterAging?.age3, filterAging?.age4);
  }, [isAgingSummary])

  const funValidateAging = (age1, age2, age3, age4) => {
    const newErrors = {
      age1: "",
      age2: "",
      age3: "",
      age4: "",
    };

    let isValid = true;


    if (Number(age1) >= Number(age2)) {
      isValid = false;
      newErrors.age1 = `Value of Age 1 must be < Age 2 (${age2})`;
    }

    // Age 2
    if (Number(age2) <= Number(age1)) {
      isValid = false;
      newErrors.age2 = `Value of Age 2 must be > Age 1 (${age1})`;
    } else if (Number(age2) >= Number(age3)) {
      isValid = false;
      newErrors.age2 = `Value of Age 2 must be < Age 3 (${age3})`;
    }

    // Age 3
    if (Number(age3) <= Number(age2)) {
      isValid = false;
      newErrors.age3 = `Value of Age 3 must be > Age 2 (${age2})`;
    } else if (Number(age3) >= Number(age4)) {
      isValid = false;
      newErrors.age3 = `Value of Age 3 must be < Age 4 (${age4})`;
    }

    if (!isValid) {
      // setApplyAging(filterAging)
      // show(<div><h6> {newErrors.age1}</h6>
      //   <h6> {newErrors.age2}</h6>
      //   <h6> {newErrors.age3}</h6>
      //   <h6> {newErrors.age4}</h6>

      // </div>)
      return newErrors;
    }
    return ""
  }


  const funFilterData = (isAging, age1, age2, age3, age4) => {
    if (isAging) {
      const valid = funValidateAging(age1, age2, age3, age4)
      if (valid != "") {
        show(<div><h6> {valid.age1}</h6>
          <h6> {valid.age2}</h6>
          <h6> {valid.age3}</h6>
          <h6> {valid.age4}</h6>

        </div>)
        return;
      }
      filterAgingGrayStock({
        data: {
          compcode: compCode.join(","),
          from_date: filterDate.start
            ? new Date(filterDate.start).toISOString().split("T")[0]
            : null,
          to_date: filterDate.end
            ? new Date(filterDate.end).toISOString().split("T")[0]
            : null,
          unit_id: selectedUnit || null,
          item_code: selectedItem != null && selectedItem && selectedItem !== "" && selectedItem !== "0" ? selectedItem : null,
          mitem_code: selectedMitem != null && selectedMitem && selectedMitem !== "" && selectedMitem != "0" ? selectedMitem : null,
          action: "Item Aging Summary",
          age1: age1,
          age2: age2,
          age3: age3,
          age4: age4
        },
      })
    }
    else {
      filterGrayStock({
        data: {
          compcode: compCode.join(","),
          from_date: filterDate.start
            ? new Date(filterDate.start).toISOString().split("T")[0]
            : null,
          to_date: filterDate.end
            ? new Date(filterDate.end).toISOString().split("T")[0]
            : null,
          unit_id: selectedUnit || null,
          item_code: selectedItem != null && selectedItem && selectedItem !== "" && selectedItem !== "0" ? selectedItem : null,
          mitem_code: selectedMitem != null && selectedMitem && selectedMitem !== "" && selectedMitem != "0" ? selectedMitem : null,
          chal_no: null,
          action: "SUMMARY",
        },
      })
    }
  }
  const handleResetAging = () => {
    // setData([])
    setFilterAging({ age1: 45, age2: 60, age3: 90, age4: 120 })
    setApplyAging({ age1: 45, age2: 60, age3: 90, age4: 120 })
    funFilterData(isAgingSummary, 45, 60, 90, 120)
  }
  const handleAgingFilter = () => {
    const valid = funValidateAging(applyAging?.age1, applyAging?.age2, applyAging?.age3, applyAging?.age4)

    if (valid != "") {
      show(<div><h6> {valid.age1}</h6>
        <h6> {valid.age2}</h6>
        <h6> {valid.age3}</h6>
        <h6> {valid.age4}</h6>

      </div>)
      return;
    }
    setFilterAging(applyAging)
    // setData([])
    funFilterData(isAgingSummary, applyAging?.age1, applyAging?.age2, applyAging?.age3, applyAging?.age4)
  }
  const handleFilter = () => {

    funFilterData(isAgingSummary, filterAging?.age1, filterAging?.age2, filterAging?.age3, filterAging?.age4)
  }

  const handleResetFilter = () => {
    setSelectedItem("")
    //{ key: "", value: "" }
    setSelectedMitem("")

    setFilterDate({ start: null, end: null })
    setSelectedUnit("")
    dispatch(resetGrayFilter())
    setIsAgingSummary(false)
    filterGrayStock({
      data: {
        compcode: compCode.join(","),
        fromdate: null,
        todate: null,
        item_code: null,
        mitem_code: null,
        chal_no: null,
        action: null,
      },
    })
  }

  //  const handleAgingFilter = () => {
  //   funFilterData(isAgingSummary, filterAging?.age1, filterAging?.age2, filterAging?.age3, filterAging?.age4)
  // }
  //const

  const INITIAL_VISIBLE_COLUMNS = useMemo(() => {

    if (isAgingSummary) {
      return ["item_code", "item_desc", aging?.Age1, aging?.Age2, aging?.Age3, aging?.Age4, aging?.Age5]
    }
    else
      return ["item_code", "item_desc", "Taka", "Meter"]

  }, [isAgingSummary, filterAging, handleResetAging])

  const columns = useMemo(() => {
    if (isAgingSummary) {
      return [
        {
          uid: "item_code",
          name: "Item Code",
          sortable: true,
        },
        {
          uid: "item_desc",
          name: "Item Desc",
          sortable: true,

          type: COLUMN_TYPE.link,
          onClick: (row) => {
            dispatch(
              setCurrentGrayStock({
                item_code: row.item_code,
              })
            )

            dispatch(setFilter({
              itemCode: selectedItem,
              mitemCode: selectedMitem,
              itemName: "",
              mitemName: "",
              unitId: selectedUnit,
              fromdate: filterDate.start,
              todate: filterDate.end,
              isAging: true
            }))

            navigate(linksUrl.grayStock.detail)
          },
        },
        {
          uid: aging?.Age1,
          name: aging?.Age1,
          type: COLUMN_TYPE.number,
          sortable: true,
          footer: {
            type: FOOTER_TYPE.text,
            label: "Total: ",
            value: totalAge1,
          },

        },
        {
          uid: aging?.Age2,
          name: aging?.Age2,
          type: COLUMN_TYPE.number,
          sortable: true,
          footer: {
            type: FOOTER_TYPE.text,
            label: "Total: ",
            value: totalAge2,
          },

        },
        {
          uid: aging?.Age3,
          name: aging?.Age3,
          type: COLUMN_TYPE.number,
          sortable: true,
          footer: {
            type: FOOTER_TYPE.text,
            label: "Total: ",
            value: totalAge3,
          },

        },
        {
          uid: aging?.Age4,
          name: aging?.Age4,
          type: COLUMN_TYPE.number,
          sortable: true,
          footer: {
            type: FOOTER_TYPE.text,
            label: "Total: ",
            value: totalAge4,
          },

        },
        {
          uid: aging?.Age5,
          name: aging?.Age5,
          type: COLUMN_TYPE.number,
          sortable: true,
          footer: {
            type: FOOTER_TYPE.text,
            label: "Total: ",
            value: totalAge5,
          },

        },
      ]

    }
    else {
      return [
        {
          uid: "item_code",
          name: "Item Code",
          sortable: true,
        },
        {
          uid: "item_desc",
          name: "Item Desc",
          sortable: true,

          type: COLUMN_TYPE.link,
          onClick: (row) => {
            dispatch(
              setCurrentGrayStock({
                item_code: row.item_code,
              })
            )

            dispatch(setFilter({
              itemCode: selectedItem,
              mitemCode: selectedMitem,
              itemName: "",
              mitemName: "",
              unitId: selectedUnit,
              fromdate: filterDate.start,
              todate: filterDate.end,
              isAging: false
            }))

            navigate(linksUrl.grayStock.detail)
          },
        },
        {
          uid: "Taka",
          name: "Taka",
          sortable: true,
          footer: {
            type: FOOTER_TYPE.text,
            label: "Total: ",
            value: totalTaka,
          },
        },
        {
          uid: "Meter",
          name: "Meter",
          sortable: true,
          footer: {
            type: FOOTER_TYPE.text,
            label: "Total: ",
            value: totalMeter,
          },
        },
      ]
    }
  }, [isAgingSummary, filterAging, handleResetAging])



  // console.log(columns, "col", INITIAL_VISIBLE_COLUMNS, data)
  const handleAgingCheckChange = (val) => {
    //setData([])
    setIsAgingSummary(val)
    // funFilterData(val, filterAging?.age1, filterAging?.age2, filterAging?.age3, filterAging?.age4)

  }
  const handleAgingChange = (e) => {
    const { value, name } = e.target
    setApplyAging({ ...applyAging, [name]: value })
  }

  const handleAgeBlur = (e) => {
    const { name, value } = e.target;
    const currentValue = Number(value);

    let isValid = true;
    let message = "";

    // if (name === "age1") {
    //   if (currentValue >= Number(applyAging.age2)) {
    //     isValid = false;
    //     message = `Value of Age 1 must be < Age 2 (${applyAging.age2})`;
    //   }
    // }

    // if (name === "age2") {
    //   if (currentValue <= Number(applyAging.age1)) {
    //     isValid = false;
    //     message = `Value of Age 2 must be > Age 1 (${applyAging.age1})`;
    //   } else if (currentValue >= Number(applyAging.age3)) {
    //     isValid = false;
    //     message = `Value of Age 2 must be < Age 3 (${applyAging.age3})`;
    //   }
    // }

    // if (name === "age3") {
    //   if (currentValue <= Number(applyAging.age2)) {
    //     isValid = false;
    //     message = `Value of Age 3 must be > Age 2 (${applyAging.age2})`;
    //   } else if (currentValue >= Number(applyAging.age4)) {
    //     isValid = false;
    //     message = `Value of Age 3 must be < Age 4 (${applyAging.age4})`;
    //   }
    // }

    // if (name === "age4") {
    //   if (currentValue <= Number(applyAging.age3)) {
    //     isValid = false;
    //     message = `Value of Age 4 must be > Age 3 (${applyAging.age3})`;
    //   }
    // }

    // if (!isValid) {
    //   setMsg(message);

    //   // Restore previous valid value
    //   setApplyAging((prev) => ({
    //     ...prev,
    //     [name]: filterAging[name],
    //   }));

    //   return;
    // }

    // Clear error
    //setMsg("");
  };

  if (isPending || isPendingAging) {
    return <LoadingCard />
  }

  if (isError || isErrorFetch || isErrorAging) {
    return <ErrorCard />
  }

  return (
    <div>
      <MainContainer pageName="Gray Stock" info={[]} breadcrumbs={["Gray Stock"]}>
        {/* filter */}
        <div className="flex flex-wrap  gap-2 mb-2 bg-gray-10 shadow p-3">
          {/* filter */}

          {/* <div id="filter" className=" flex flex-wrap items-center   gap-4 "> */}
          {/* date */}

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label={"Start Date"}
              views={["day", "month", "year"]}
              format="DD/MM/YYYY"
              value={
                filterDate.start
                  ? dayjs(filterDate.start)
                  : filterDate.start
              }
              onChange={(newValue) => {
                setFilterDate((prev) => {
                  return { ...prev, start: dayjs(newValue).format("YYYY-MM-DD") }
                })
              }}
              sx={{ width: "145px" }}
              slotProps={{ textField: { size: "small" } }}
            />
            <DatePicker
              label={"End Date"}
              views={["day", "month", "year"]}
              format="DD/MM/YYYY"
              value={
                filterDate.end ? dayjs(filterDate.end) : filterDate.end
              }
              onChange={(newValue) => {
                setFilterDate((prev) => {
                  return { ...prev, end: dayjs(newValue).format("YYYY-MM-DD") }
                })
              }}
              slotProps={{ textField: { size: "small" } }}
              sx={{ width: "145px" }}
            />
          </LocalizationProvider>
          {/*  end of date */}
          <div className={`${isMobile ? "flex-wrap" : ""} flex  items-center gap-2 `}>
            <Autocomplete
              size="sm"
              name={enum_filterFieldId.unit}
              // isInvalid={errors[item.name]}
              // errorMessage={errors[item.name]}
              label={"Unit"}
              eventResizeFeature={true}
              selectionMode="single"
              showScrollIndicators={true}
              placeholder={"--Select--"}
              className="max-w-23"
              color="warning"
              isClearable={true}
              variant="flat"
              isVirtualized
              defaultItems={
                unitMaster || []
              }
              onSelectionChange={setSelectedUnit}
              selectedKey={selectedUnit}
            >
              {(list) => (
                <AutocompleteItem

                  key={list.Party_Id}
                >
                  {list.Party_Name}
                </AutocompleteItem>
              )}
            </Autocomplete>
            <Autocomplete
              size="sm"
              name={enum_filterFieldId.item}
              label={"Item Name"}
              eventResizeFeature={true}
              selectionMode="single"
              showScrollIndicators={true}
              placeholder={"--Select--"}
              className={`${isMobile ? "w-full" : "max-w-42"} `}
              isClearable={true}
              variant="bordered"
              isVirtualized
              defaultItems={
                itemDetails && itemDetails.itemMaster
                  ? itemDetails.itemMaster
                  : []
              }
              onSelectionChange={setSelectedItem}
              selectedKey={selectedItem}
            >
              {(list) => (
                <AutocompleteItem

                  key={list.Item_Code}
                >
                  {list.Item_CodeNDesc}
                </AutocompleteItem>
              )}
            </Autocomplete>
            <Autocomplete
              size="sm"
              name={enum_filterFieldId.item}
              label={"M Item Name"}
              eventResizeFeature={true}
              selectionMode="single"
              showScrollIndicators={true}
              placeholder={"--Select--"}
              className={`${isMobile ? "w-full" : "max-w-42"} `}
              isClearable={true}
              variant="bordered"
              isVirtualized
              defaultItems={
                itemDetails && itemDetails.mitemMaster
                  ? itemDetails.mitemMaster
                  : []
              }
              onSelectionChange={setSelectedMitem}
              selectedKey={selectedMitem}
            >
              {(list) => (
                <AutocompleteItem

                  key={list.Item_Code}
                >
                  {list.Item_CodeNDesc}
                </AutocompleteItem>
              )}
            </Autocomplete>

          </div>

          <Button
            size="sm"
            color="primary"
            startContent={<FontAwesomeIcon icon={faMagnifyingGlass} />}
            onPress={handleFilter}

          // isLoading={isPending}
          >
            Search
          </Button>
          <Button
            size="sm"
            style={{ marginLeft: "5px" }}
            color="primary"
            startContent={<FontAwesomeIcon icon={faFilter} />}
            onPress={handleResetFilter}

          >
            Reset
          </Button>
          {/* </div> */}

          {/* end of filter */}
        </div>
        <div className="items-center  my-3 flex justify-end gap-5 ">
          <Checkbox size="md"
            classNames={{ "label": "text-white text-xs font-semibold" }}
            className="py-1 px-2  h-8 w-full rounded-md uppercase bg-blue-700 border-blue-200 text-rose-700 border-0" label="gfu"
            color={"danger"} isSelected={isAgingSummary}
            onValueChange={(e) => handleAgingCheckChange(e)}>
            <FontAwesomeIcon className="mr-2" icon={faList} ></FontAwesomeIcon>
            Aging Summary </Checkbox>
          {isAgingSummary ?
            <div className="flex justify-end">
              <Popover placement="bottom" variant="bordered"
                //isDismissable={false}
                shouldCloseOnBlur={false}
                shouldBlockScroll={true}
                shouldCloseOnScroll={false}
                showArrow={true}>
                <PopoverTrigger>

                  <button
                    type="button"

                    className="
                                                inline-flex items-center gap-2
                                                rounded-md
                                                border border-pink-700
                                                bg-pink-50
                                                px-2 py-1 
                                                text-xs uppercase font-medium text-rose-500
                                                shadow-sm
                                                transition-all duration-200
                                                hover:border-rose-300
                                                hover:bg-rose-100
                                                hover:text-rose-800
                                                hover:shadow
                                                focus:outline-none
                                                ring-2 ring-rose-400 focus:ring-offset-1
                                                active:scale-[0.98]
                                            "
                  >
                    <FontAwesomeIcon
                      icon={faFilter}
                      className="text-pink-600  font-semibold"
                    />

                    <span> Filter Aging</span>
                  </button>


                </PopoverTrigger>
                <PopoverContent className="z-[1000]">
                  <div
                    className="p-2"
                    onMouseDown={(e) => e.stopPropagation()}
                    onTouchStart={(e) => e.stopPropagation()}
                  >

                    {/* {msg && <div className="text-red-500 bg-red-50 text-sm p-1">{msg}</div>} */}
                    <div className="grid grid-cols-2 gap-x-3 gap-y-2">
                      <Input
                        type="text"
                        ref={inputRef}
                        label="Age 1"
                        name="age1"
                        color="success"
                        isRequired
                        placeholder=" "
                        variant="bordered"
                        labelPlacement="outside"
                        className="w-20 bg-white"
                        classNames={{
                          label: "text-xs font-semibold text-orange-600 uppercase",
                          input: "text-sm font-semibold",
                        }}
                        size="sm"
                        onFocus={(e) => e.target.select()}
                        onBlur={handleAgeBlur}
                        value={applyAging?.age1 ?? ""}
                        onChange={(e) => handleAgingChange(e)}
                      />

                      <Input
                        type="text"
                        label="Age 2"
                        ref={inputRef}
                        name="age2"
                        color="success"
                        isRequired
                        placeholder=" "
                        variant="bordered"
                        labelPlacement="outside"
                        className="w-20 bg-white"
                        onFocus={(e) => e.target.select()}
                        classNames={{
                          label: "text-xs font-semibold text-orange-600 uppercase",
                          input: "text-sm font-semibold",
                        }}
                        size="sm"
                        value={applyAging?.age2 ?? ""}
                        onBlur={handleAgeBlur}
                        onChange={(e) => handleAgingChange(e)}
                      />

                      <Input
                        type="text"
                        label="Age 3"
                        name="age3"
                        ref={inputRef}
                        color="success"
                        isRequired
                        placeholder=" "
                        variant="bordered"
                        labelPlacement="outside"
                        onBlur={handleAgeBlur}
                        className="w-20 bg-white"
                        onFocus={(e) => e.target.select()}
                        classNames={{
                          label: "text-xs font-semibold text-orange-600 uppercase",
                          input: "text-sm font-semibold",
                        }}
                        size="sm"
                        value={applyAging?.age3 ?? ""}
                        onChange={(e) => handleAgingChange(e)}
                      />

                      <Input
                        type="text"
                        label="Age 4"
                        name="age4"
                        ref={inputRef}
                        color="success"
                        isRequired
                        placeholder=" "
                        variant="bordered"
                        labelPlacement="outside"
                        onBlur={handleAgeBlur}
                        className="w-20 bg-white"
                        onFocus={(e) => e.target.select()}
                        classNames={{
                          label: "text-xs font-semibold text-orange-600 uppercase",
                          input: "text-sm font-semibold",
                        }}
                        size="sm"
                        value={applyAging?.age4 ?? ""}
                        onChange={(e) => handleAgingChange(e)}
                      />
                    </div>


                    <div className="mt-5 flex justify-center gap-2 border-t border-gray-200 pt-3">


                      <Button
                        onPress={handleAgingFilter}
                        color="danger"
                        variant="shadow"
                        size="sm"
                        className="font-semibold h-7"

                      >
                        Apply
                      </Button>
                      <Button
                        onPress={handleResetAging}
                        color="warning"
                        variant="flat"
                        size="sm"
                        className="font-semibold h-7"
                      >
                        Reset
                      </Button>
                    </div>


                  </div>
                </PopoverContent>
              </Popover >
            </div> : ""}
        </div>
        {/* end of filter */}
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          columns={columns}
          exportColumns={exportColumns}
          downloadDataFooter={downloadDataFooter}
          downloadFileName="Gray_Stock"
          showAdvanceFilter={false}
          id={isAgingSummary ? "item_desc" : "item_desc"}
        />
      </MainContainer>
    </div>
  )
}

export default GrayStock
